import { render, staticRenderFns } from "./AdminPanel.Vue?vue&type=template&id=50d7dc6c"
import script from "./AdminPanel.Vue?vue&type=script&lang=js"
export * from "./AdminPanel.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/AdminPanel.Vue
// module id = 241
// module chunks = 0